import actionTypes from './actionTypes'

const gameActions = {

	addQuestion() {
		return {
			type: actionTypes.GAME_ADD_QUESTION,
		}
	},

	addAnswer(activityId) {
		return {
			type: actionTypes.GAME_QUESTION_ADD_ANSWER,
			activityId,
		}
	},

	answerFocus(activityId, answerId) {
		return {
			type: actionTypes.GAME_QUESTION_ANSWER_FOCUS,
			activityId,
			answerId,
		}
	},

	dragQuestionAnswer(draggedAnswer, replacedAnswer) {
		return {
			type: actionTypes.GAME_QUESTION_ANSWER_DRAG,
			draggedAnswer,
			replacedAnswer,
		}
	},

	dropQuestionAnswer(activityId, answerId) {
		return {
			type: actionTypes.GAME_QUESTION_ANSWER_DROP,
			activityId,
			answerId,
		}
	},

	toggleCollapseActivity(activityId) {
		return {
			type: actionTypes.GAME_COLLAPSE_ACTIVITY,
			activityId,
		}
	},

	collapseAll() {
		return {
			type: actionTypes.GAME_COLLAPSE_ALL,
		}
	},

	expandAll() {
		return {
			type: actionTypes.GAME_EXPAND_ALL,
		}
	},

	initializeDataSuccess(payload) {
		return {
			type: actionTypes.GAME_INITIALIZE_DATA_SUCCESS,
			payload,
		}
	},

	activityCreated(activityId, serverId, questionUid) {
		return {
			type: actionTypes.GAME_ACTIVITY_CREATED_SUCCESS,
			activityId,
			serverId,
			questionUid,
		}
	},

	deleteActivity(activityId) {
		return {
			type: actionTypes.GAME_DELETE_ACTIVITY,
			activityId,
		}
	},

	deleteActivityCancel(activityId) {
		return {
			type: actionTypes.GAME_DELETE_ACTIVITY_CANCEL,
			activityId,
		}
	},

	deleteActivityConfirm(activityId) {
		return {
			type: actionTypes.GAME_DELETE_ACTIVITY_CONFIRMED,
			activityId,
		}
	},

	activityDeleted(activityId) {
		return {
			type: actionTypes.GAME_DELETE_ACTIVITY_SUCCESS,
			activityId,
		}
	},

	answerCorrectToggle(activityId, answerId) {
		return {
			type: actionTypes.GAME_QUESTION_ANSWER_CORRECT_TOGGLE,
			activityId,
			answerId,
		}
	},

	answerChange(value, activityId, answerId) {
		return {
			type: actionTypes.GAME_QUESTION_ANSWER_CHANGE,
			value,
			activityId,
			answerId,
		}
	},

	questionChange(value, activityId) {
		return {
			type: actionTypes.GAME_QUESTION_CHANGE,
			value,
			activityId,
		}
	},

	deleteAnswer(activityId, answerId) {
		return {
			type: actionTypes.GAME_QUESTION_ANSWER_DELETE,
			activityId,
			answerId,
		}
	},

	answerSave(activityId) {
		return {
			type: actionTypes.GAME_QUESTION_ANSWER_SAVE,
			activityId,
		}
	},

	activitySaved(activityId, answers) {
		return {
			type: actionTypes.GAME_ACTIVITY_SAVED,
			activityId,
			answers,
		}
	},

	activitySaveFailed() {
		return {
			type: actionTypes.GAME_ACTIVITY_FAILED,
		}
	},

	gameSave() {
		return {
			type: actionTypes.GAME_SAVE,
		}
	},

	gameSaveFailed(error) {
		return {
			type: actionTypes.GAME_SAVE_FAILED,
			error,
		}
	},

	gameSaveSuccess() {
		return {
			type: actionTypes.GAME_SAVE_SUCCESS,
		}
	},

	gameCancel() {
		return {
			type: actionTypes.GAME_CANCEL,
		}
	},

	gameCancelConfirmed() {
		return {
			type: actionTypes.GAME_CANCEL_CONFIRMED,
		}
	},

	gameCancelCancelled() {
		return {
			type: actionTypes.GAME_CANCEL_CANCELLED,
		}
	},

	editQuestionTimer(id, value) {
		return {
			type: actionTypes.GAME_QUESTION_TIMER_EDIT,
			id,
			value,
		}
	},

	cancelQuestionTimer() {
		return {
			type: actionTypes.GAME_QUESTION_TIMER_CANCEL,
		}
	},

	saveQuestionTimer(activityId, value) {
		return {
			type: actionTypes.GAME_QUESTION_TIMER_SAVE,
			activityId,
			value,
		}
	},

	selectAnswerTypeHandler(activityId, value, isConfirmed = false) {
		return {
			type: actionTypes.GAME_QUESTION_SELECT_ANSWER_TYPE,
			activityId,
			value,
			isConfirmed,
		}
	},

	selectAnswerTypeCancel() {
		return {
			type: actionTypes.GAME_QUESTION_SELECT_ANSWER_TYPE_CANCELLED,
		}
	},

	answerMediaPickerSelected(allowedTypes, files, questionId, answerId) {
		return {
			type: actionTypes.GAME_UPLOAD_ANSWER_MEDIA_SELECTED,
			allowedTypes,
			files,
			questionId,
			answerId,
		}
	},

	answerMediaPickerCancelled() {
		return {
			type: actionTypes.GAME_UPLOAD_ANSWER_MEDIA_CANCELLED,
		}
	},

	answerMediaPickerFailed(questionId, answerId) {
		return {
			type: actionTypes.GAME_UPLOAD_ANSWER_MEDIA_FAILED,
			questionId,
			answerId,
		}
	},

	addAnswerMedia(questionId, answerId) {
		return {
			type: actionTypes.GAME_UPLOAD_ANSWER_MEDIA_ADD,
			questionId,
			answerId,
		}
	},

	previewAnswerMedia(questionId, answerId) {
		return {
			type: actionTypes.GAME_UPLOAD_ANSWER_MEDIA_PREVIEW,
			questionId,
			answerId,
		}
	},

	deleteAnswerMedia(activityId, answerId) {
		return {
			type: actionTypes.GAME_UPLOAD_ANSWER_MEDIA_DELETE,
			activityId,
			answerId,
		}
	},

	answerMediaUploadSuccess(questionId, answerId, answer) {
		return {
			type: actionTypes.GAME_UPLOAD_ANSWER_MEDIA_SUCCESS,
			questionId,
			answerId,
			answer,
		}
	},

	dragQuestion(draggedQuestion, replacedQuestion) {
		return {
			type: actionTypes.GAME_DRAG_QUESTION,
			draggedQuestion,
			replacedQuestion,
		}
	},

	dropQuestion() {
		return {
			type: actionTypes.GAME_DROP_QUESTION,
		}
	},

	sortQuestionsSuccess() {
		return {
			type: actionTypes.GAME_SORT_SUCCESS,
		}
	},

	sortQuestionsFailed() {
		return {
			type: actionTypes.GAME_SORT_FAILED,
		}
	},

	duplicateQuestion(activityId) {
		return {
			type: actionTypes.GAME_QUESTION_DUPLICATE,
			activityId,
		}
	},

	activityDuplicated(clientActivityData, serverActivityData) {
		return {
			type: actionTypes.GAME_QUESTION_DUPLICATE_SUCCESS,
			clientActivityData,
			serverActivityData,
		}
	},

	addQuestionMedia(mediaType, questionId) {
		return {
			type: actionTypes.GAME_UPLOAD_QUESTION_MEDIA_ADD,
			mediaType,
			questionId,
		}
	},

	questionMediaPickerCancelled() {
		return {
			type: actionTypes.GAME_UPLOAD_QUESTION_MEDIA_CANCELLED,
		}
	},

	questionMediaPickerSelected(allowedTypes, files, questionId) {
		return {
			type: actionTypes.GAME_UPLOAD_QUESTION_MEDIA_SELECTED,
			allowedTypes,
			files,
			questionId,
		}
	},

	questionMediaPickerError(message, questionId) {
		return {
			type: actionTypes.GAME_UPLOAD_QUESTION_MEDIA_ERROR,
			message,
			questionId,
		}
	},

	questionMediaPickerSuccess(questionId, icon) {
		return {
			type: actionTypes.GAME_UPLOAD_QUESTION_MEDIA_SUCCESS,
			questionId,
			icon,
		}
	},

	questionMediaPickerFailed(error, message, questionId) {
		return {
			type: actionTypes.GAME_UPLOAD_QUESTION_MEDIA_FAILED,
			error,
			message,
			questionId,
		}
	},

	deleteQuestionMedia(questionId, iconId) {
		return {
			type: actionTypes.GAME_UPLOAD_QUESTION_MEDIA_DELETE,
			questionId,
			iconId,
		}
	},

	deleteQuestionMediaSuccess(questionId) {
		return {
			type: actionTypes.GAME_UPLOAD_QUESTION_MEDIA_DELETE_SUCCESS,
			questionId,
		}
	},

	deleteQuestionMediaFailed(error, message, questionId) {
		return {
			type: actionTypes.GAME_UPLOAD_QUESTION_MEDIA_DELETE_FAILED,
			error,
			message,
			questionId,
		}
	},

	initializeSlideDataSuccess(payload) {
		return {
			type: actionTypes.GAME_INITIALIZE_SLIDE_DATA_SUCCESS,
			payload,
		}
	},
}

export default gameActions
